<template>
  <div class="w-100" id="dlnkdataroom">

    <div class="bg-primary" style="background-image: url({$img_dir}components/abstract-shapes-20.svg);">
      <div class="container space-1">
        <div class="row col-12 d-flex justify-content-center px-3 mb-2">
          <h1 class="text-white mx-auto">Documents</h1>
        </div>

<!--        <div class="row d-flex justify-content-center my-4">-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 1</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 2</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 3</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 4</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 5</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 6</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 7</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 8</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 9</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2" href="#">Thème 10</a>-->
<!--          <a class="badge badge-secondary text-left mx-1 mb-2 badge" href="#">+ Ajouter thème</a>-->
<!--        </div>-->

        <div class="row d-flex col-12 align-items-center justify-content-center">
          <button type="button" class="col-3 col-lg-2 btn btn-light btn-block btn-lg"><i class="fa fa-filter mr-2"></i>Trier par</button>

          <div class="col-9 col-lg-5 pr-0 js-focus-state input-group input-group-sm">
            <div class="input-group-prepend">
                        <span class="input-group-text">
                          <span class="fas fa-search"></span>
                        </span>
            </div>
            <input id="datatableSearch" class="form-control" type="email" placeholder="Rechercher un document" aria-label="Rechercher un document">
          </div>
        </div>
      </div>
    </div>

    <div class="container space-1">
      <!-- Title -->
      <div class="mb-3 d-flex align-items-center justify-content-between">
        <h2 class="h4 mb-0">Dossiers : <span class="text-muted">Bootcamp > Promo 2 > Maquettes</span></h2>

        <!-- Nav -->
        <ul class="nav nav-segment bg-soft-primary">
          <li class="list-inline-item">
            <a class="nav-link" v-bind:class="{ active: grid }" aria-expanded="true" @click="view_grid()">
              <i class="fas fa-th-large"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a class="nav-link" v-bind:class="{ active: list }" @click="view_list()">
              <i class="fas fa-list"></i>
            </a>
          </li>
        </ul>
        <!-- End Nav -->
      </div>
      <!-- End Title -->


      <div v-if="grid" class="row collapse" v-bind:class="{ show: grid }" id="gridView">
          <div class="row mb-3" style="position: relative;">
            <a class="btn btn-primary shadow-soft rounded-circle" href="#" role="button"
               style="position: absolute; bottom: 50%; right: 10px; transform: translate(50%, 50%); z-index: 9999;">
              <span class="fa fa-arrow-right"></span>
            </a>
            <a class="btn btn-primary shadow-soft rounded-circle" href="#" role="button"
               style="position: absolute; bottom: 50%; left: 10px; transform: translate(-50%, 50%); z-index: 9999;">
              <span class="fa fa-arrow-left"></span>
            </a>

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card shadow-primary-lg bg-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0 text-white">Ajouter un dossier</h4>
                  </div>
                  <i class="fas fa-plus-circle text-white"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Documents administratifs</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Projets</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Achats</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Projets</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Documents administratifs</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Projets</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->

            <!-- Blog -->
            <article class="col-sm-6 col-md-4 col-lg-3 my-1">
              <a class="card bg-soft-primary p-3" href="javascript:void(0);">
                <div class="media align-items-center">
                  <div class="media-body mr-2">
                    <h4 class="h6 mb-0">Achats</h4>
                  </div>
                  <i class="fas fa-edit mr-2 text-info" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i class="fas fa-folder-open"></i>
                </div>
              </a>
            </article>
            <!-- End Blog -->
          </div>

          <!-- Title -->
          <div class="mb-3 d-flex align-items-center justify-content-between">
            <h2 class="h4 mb-0">Documents</h2>
          </div>
          <!-- End Title -->

          <div class="row mb-3">
            <div class="col-sm-6 col-lg-4 mb-3 transition-3d-hover">
              <!-- Blog Card -->
              <article class="card shadow-primary-lg border h-100">
                <div class="card-body d-flex align-items-center justify-content-center py-1 mb-1 mt-4">
                  <img class="text-center" src="/modules/testmaquette/img/upload.png" style="width: 50px; height: 50px;">
                </div>
                <div class="card-footer border-0 p-3">
                  <p class="h3 text-center text-primary">Nouveau document</p>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>

            <div class="col-sm-6 col-lg-4 mb-3">
              <!-- Blog Card -->
              <article class="card shadow-lg border h-100">
                <div class="card-body pb-0">
                  <h3 class="h5 mb-0"><a href="blog-single-article.html">Announcing Front Tutorials</a></h3>
                  <p class="mb-0">A new tutorial to make it easier to master Adobe Ai.</p>
                </div>
                <div class="card-footer border-0 pt-3">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <small class="d-block">Laurie Paris</small>
                      <small class="d-block">July 15</small>
                    </div>
                    <div class="media-body d-flex justify-content-end text-center">
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-play-circle"></i>
                      </a>
                      <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-edit"></i>
                      </a>
                      <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>

            <div class="col-sm-6 col-lg-4 mb-3">
              <!-- Blog Card -->
              <article class="card shadow-lg border h-100">
                <div class="card-body pb-0">
                  <h3 class="h5 mb-0"><a href="blog-single-article.html">Announcing Front Tutorials</a></h3>
                  <p class="mb-0">A new tutorial to make it easier to master Adobe Ai.</p>
                </div>
                <div class="card-footer border-0 pt-3">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <small class="d-block">Laurie Paris</small>
                      <small class="d-block">July 15</small>
                    </div>
                    <div class="media-body d-flex justify-content-end text-center">
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-eye"></i>
                      </a>
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-download"></i>
                      </a>
                      <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-edit"></i>
                      </a>
                      <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>

            <div class="col-sm-6 col-lg-4 mb-3">
              <!-- Blog Card -->
              <article class="card shadow-lg border h-100">
                <div class="card-body pb-0">
                  <h3 class="h5 mb-0"><a href="blog-single-article.html">Announcing Front Tutorials</a></h3>
                  <p class="mb-0">A new tutorial to make it easier to master Adobe Ai.</p>
                </div>
                <div class="card-footer border-0 pt-3">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <small class="d-block">Laurie Paris</small>
                      <small class="d-block">July 15</small>
                    </div>
                    <div class="media-body d-flex justify-content-end text-center">
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-play-circle"></i>
                      </a>
                      <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-edit"></i>
                      </a>
                      <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>

            <div class="col-sm-6 col-lg-4 mb-3">
              <!-- Blog Card -->
              <article class="card shadow-lg border h-100">
                <div class="card-body pb-0">
                  <h3 class="h5 mb-0"><a href="blog-single-article.html">Announcing Front Tutorials</a></h3>
                  <p class="mb-0">A new tutorial to make it easier to master Adobe Ai.</p>
                </div>
                <div class="card-footer border-0 pt-3">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <small class="d-block">Laurie Paris</small>
                      <small class="d-block">July 15</small>
                    </div>
                    <div class="media-body d-flex justify-content-end text-center">
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-play-circle"></i>
                      </a>
                      <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-edit"></i>
                      </a>
                      <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>

            <div class="col-sm-6 col-lg-4 mb-3">
              <!-- Blog Card -->
              <article class="card shadow-lg border h-100">
                <div class="card-body pb-0">
                  <h3 class="h5 mb-0"><a href="blog-single-article.html">Announcing Front Tutorials</a></h3>
                  <p class="mb-0">A new tutorial to make it easier to master Adobe Ai.</p>
                </div>
                <div class="card-footer border-0 pt-3">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <small class="d-block">Laurie Paris</small>
                      <small class="d-block">July 15</small>
                    </div>
                    <div class="media-body d-flex justify-content-end text-center">
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-eye"></i>
                      </a>
                      <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-download"></i>
                      </a>
                      <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                        <i class="fas fa-edit"></i>
                      </a>
                      <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </article>
              <!-- End Blog Card -->
            </div>
          </div>
        </div>

      <div v-if="list" class="row collapse pl-2" v-bind:class="{ show: list }" id="listView">
          <div class="row d-flex justify-content-md-start justify-content-center mx-2 mb-3">
            <div class="mx-3 col-auto">
              <a class="btn btn-primary text-white"><i class="fa fa-plus-circle mr-2"></i>Nouveau dossier</a>
            </div>
            <div class="">
              <a class="btn btn-primary text-white"><i class="fa fa-plus-circle mr-2"></i>Nouveau document</a>
            </div>
          </div>

          <table class="table table-light">
            <thead class="">
            <tr>
              <th scope="col"></th> <!-- Dossier ou fichier -->
              <th scope="col">Nom</th>
              <th scope="col">Thème</th>
              <th scope="col">Propriétaire</th>
              <th scope="col">Modifié le</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody class="font-size-1">
            <tr>
              <td class="align-middle"><i class="fa fa-folder text-primary"></i></td>
              <td class="align-middle text-primary font-weight-bold">Dossier bootcamp 1</td>
              <td class="align-middle text-success">Thème 1</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-eye"></i>
                </a>
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-download"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="align-middle"><i class="fa fa-folder text-primary"></i></td>
              <td class="align-middle text-primary font-weight-bold">Dossier bootcamp 3</td>
              <td class="align-middle text-warning">Thème 2</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-eye"></i>
                </a>
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-download"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="align-middle"><i class="fa fa-file"></i></td>
              <td class="align-middle text-primary">Vidéo</td>
              <td class="align-middle text-success">Thème 1</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-play-circle"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="align-middle"><i class="fa fa-file"></i></td>
              <td class="align-middle text-primary">Document support</td>
              <td class="align-middle text-warning">Thème 2</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-eye"></i>
                </a>
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-download"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="align-middle"><i class="fa fa-file"></i></td>
              <td class="align-middle text-primary">Document support</td>
              <td class="align-middle text-success">Thème 1</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-eye"></i>
                </a>
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-download"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>

            <tr>
              <td class="align-middle"><i class="fa fa-file"></i></td>
              <td class="align-middle text-primary">Document support</td>
              <td class="align-middle text-warning">Thème 2</td>
              <td class="align-middle">Nicolas Aires</td>
              <td class="align-middle font-italic">25/07/2021</td>
              <td class="text-right">
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-eye"></i>
                </a>
                <a href="#" class="btn btn-primary btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-download"></i>
                </a>
                <a href="#" class="btn btn-info btn-pill btn-icon btn-xs mr-2">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" class="btn btn-danger btn-pill btn-icon btn-xs">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

    </div>
    <!-- End Blog Card Section -->

    <!-- Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Modifier le dossier</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="folderName">Nom du dossier</label>
              <input type="text" class="form-control" id="folderName" placeholder="Nom_actuel">
            </div>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-info"><i class="fa fa-file-archive mr-2"></i>Télécharger en zip</button>
              <button type="button" class="btn btn-danger justify-content-end"><i class="fa fa-trash mr-2"></i>Supprimer le dossier</button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button type="button" class="btn btn-primary">Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data: function () {
    return {
      grid: true,
      list: false,
    }
  },

  mounted() {
  },

  computed: {
  },

  methods: {

    view_grid: function () {
      this.grid = true
      this.list = false
    },

    view_list: function () {
      this.grid = false
      this.list = true
    }


  },
}
</script>

<style scoped>
</style>